import React from "react";
import { getValue } from "@utils/lodash";

function ImpactAssessmentSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <defs>
        <clipPath id="clip-path-impact-assessment">
          <rect id="Rectangle_18146" data-name="Rectangle 18146" width="18" height="18" transform="translate(-11994 -5525)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Group_10473" data-name="Group 10473" transform="translate(-159 -1902)">
        <g id="Group_10461" data-name="Group 10461">
          <circle id="Ellipse_3667" data-name="Ellipse 3667" cx="16" cy="16" r="16" transform="translate(159 1902)" fill="#f3e8fc"/>
          <g id="Mask_Group_256" data-name="Mask Group 256" transform="translate(12160 7434)" clip-path="url(#clip-path-impact-assessment)">
            <path id="query_stats_FILL0_wght300_GRAD0_opsz24" d="M2.073-6.263l-.945-.688,3.63-5.83,2.321,2.717,3.08-5.016L12.007-12.3a4.587,4.587,0,0,0-.626.092,4.187,4.187,0,0,0-.582.175l-.6-.894L7.247-8.1l-2.34-2.736L2.073-6.263ZM16.786-2.518l-2.537-2.53a2.734,2.734,0,0,1-.8.4,3.081,3.081,0,0,1-.914.136,2.981,2.981,0,0,1-2.195-.9,3,3,0,0,1-.9-2.2,3,3,0,0,1,.9-2.2,2.981,2.981,0,0,1,2.195-.9,2.981,2.981,0,0,1,2.195.9,3,3,0,0,1,.9,2.2,3.1,3.1,0,0,1-.139.928,2.873,2.873,0,0,1-.41.823l2.537,2.519ZM12.531-5.677A1.864,1.864,0,0,0,13.9-6.24a1.877,1.877,0,0,0,.561-1.378A1.877,1.877,0,0,0,13.9-9a1.864,1.864,0,0,0-1.373-.563A1.864,1.864,0,0,0,11.158-9,1.877,1.877,0,0,0,10.6-7.618a1.877,1.877,0,0,0,.561,1.378A1.864,1.864,0,0,0,12.531-5.677ZM14.1-12.022a4.272,4.272,0,0,0-.571-.181,3.477,3.477,0,0,0-.606-.09l3.757-5.975.945.688L14.1-12.022Z" transform="translate(-11994.378 -5505.607)" fill="#8339cb"/>
          </g>
        </g>
      </g>
    </svg>

  );
}

export default ImpactAssessmentSvgComponent;
